import React, {useContext} from "react";
import {Dialog} from "@mui/material";
import {Link} from "react-router-dom";
import PropTypes from "prop-types";
import {
    Boat,
    CloseIcon,
    DialogContent,
    GotItButton,
    Header,
    ReservationDataTable,
    Subtitle,
    Title,
    Wrapper
} from "./styles";
import close from '../../../../assets/images/reservation/close.svg';
import boat from '../../../../assets/images/reservation/success-boat.svg';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {selectBoaterFirstName, selectBoaterMail, selectIsRequest, selectReservationDetails} from "../../../../store/slices/reservation/selectors";
import {selectIframe, selectMarina} from "../../../../store/slices/app/selectors";
import {AuthContext} from "../../../../context/AuthProvider";

const ReservationSuccessDialog = props => {
    const {open, redirectUrl, onClose=()=>{}} = props;
    const {t} = useTranslation();
    const name = useSelector(selectBoaterFirstName);
    const mail = useSelector(selectBoaterMail);
    const { user: boater } = useContext(AuthContext);
    const marina = useSelector(selectMarina);
    const reservationDetails = useSelector(selectReservationDetails);
    const isRequest = useSelector(selectIsRequest);
    const isIframe = useSelector(selectIframe)

    const handleRedirect = () => {
        onClose();
        window.location.replace(redirectUrl);
      }

    return <Dialog open={open} maxWidth="lg" fullScreen PaperProps={{
        style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            boxSizing: 'border-box',
            display: "flex",
            alignItems: 'center',
            justifyContent: 'center',
        },
    }}>
        <Wrapper>
            {!isIframe &&<Link to="#" target="_top">
                <CloseIcon onClick={handleRedirect} src={close}/>
            </Link>}
            { isIframe && <a href={redirectUrl} target="_top" >
                <CloseIcon onClick={onClose} src={close}/>
            </a>}
            <Header />
            <DialogContent>
                <Title>{t('THANK_YOU_USER', {name: name || boater?.first_name || undefined})}</Title>
                <ReservationDataTable>
                    <tr>
                    <Subtitle colSpan={2}>
                        {(reservationDetails && isRequest) ?
                            t('INQUIRY_SENT_TO_MARINA')
                            :
                            t('YOU_RESERVED_BERTH_AT', {marina: marina?.name || '-'})}
                    </Subtitle>
                    </tr>
                    <tr>
                        <td>
                            {t((reservationDetails && isRequest) ?
                                'RESERVATION_REQUEST_NUMBER' : 'RESERVATION_NUMBER')}
                        </td>
                        <td className="value-item">{reservationDetails?.view_id || '-'}</td>
                    </tr>
                    <tr>
                        <td>{t((reservationDetails && isRequest) ? 'REQ_CONFIRMATION_SENT_TO' : 'CONFIRMATION_SENT_TO')}</td>
                        <td className="value-item">{mail || boater?.email}</td>
                    </tr>
                    { reservationDetails && !isRequest && <tr>
                        <td>{t('CREDIT_STATEMENT_WILL_SHOW')}</td>
                        <td>www.pickapier.com</td>
                    </tr>}
                </ReservationDataTable>
                { !isIframe && <Link  to="#" target="_top" style={{textDecoration: 'none'}}>
                    <GotItButton onClick={handleRedirect}>{t('GOT_IT')}</GotItButton>
                </Link>}
                { isIframe &&
                <a href={redirectUrl} >
                    <GotItButton onClick={onClose}>{t('GOT_IT')}</GotItButton>
                </a>
                }
            </DialogContent>
            <Boat src={boat} />
        </Wrapper>
    </Dialog>
}

ReservationSuccessDialog.propTypes = {
    open: PropTypes.bool,
    redirectUrl: PropTypes.string
}

export default ReservationSuccessDialog;
